import React from 'react';
import PropTypes from 'prop-types';
import ExternalLink from './ExternalLink';

const ForgetPassword = ({ url }) => (
  <div className="input-group-forget-password">
    <ExternalLink url={url} className="main__forget-password" tatget="_self" rel="">
      Forgot password
    </ExternalLink>
  </div>
);

ForgetPassword.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ForgetPassword;
